// import RepositoryFactory from "@/apis";
// const newsletter = RepositoryFactory.newsletter;
import newsletter from "../../apis/newsletter";

export default {
  createNewsletter({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await newsletter.createNewsletter(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getNewsletter({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await newsletter.getNewsletter(payload);
        commit("GET_NEWSLETTER", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  subscribeToNewsletter({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await newsletter.subscribeToNewsletter(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  //medical thoughts
  medicalThoughts({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await newsletter.medicalThoughts(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
